import { render, staticRenderFns } from "./SaxxDatePicker.vue?vue&type=template&id=94d0ed36"
import script from "./SaxxDatePicker.vue?vue&type=script&lang=js"
export * from "./SaxxDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports